import React, { Component } from "react";
import { connect } from "react-redux";
import { adminService } from "../../_services/admin.service";
import {
  Button,
  Table,
  Drawer,
  PageHeader,
  DatePicker,
  Space,
  Modal,
  Radio,
  message,
} from "antd";
import {
  BarChartOutlined,
  TeamOutlined,
  EnvironmentOutlined,
  BankOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import moment from "moment";
import * as XLSX from "xlsx-js-style";
import { LanguageContext } from "../../context/LanguageContext";
import { ImageView } from "../image/imageView";
import { ViewFormModel } from "../ProfessionalForm/ViewForm/ViewFormModel";
import { professionalAction } from "../../_actions";
import CctvPatternOverviewStatic from "./CctvPatternOverviewStatic";

class ApiLog extends Component {
  static contextType = LanguageContext;
  state = {
    data: [],
    loading: false,
    columns: [],
    activeRange: "daily",
    startDate: moment(),
    endDate: moment(),
    pagination: {
      current: 1,
      pageSize: 10,
    },

    drawerVisible: false,
    detailLoading: false,
    detailData: [],
    detailPagination: {
      page: 1,
      limit: 10,
      total: 0,
    },
    selectedApi: null,
    selectedIP: null,
    is_show: false,
    imageOpen: false,
    selectedImage: "",
    crime_id: "",
    name: "",

    // Graph / analysis drawer
    graphDrawerVisible: false,
    graphLoading: false,
    graphType: "master_id",
    graphSummary: { distinctCount: 0, totalCount: 0 },
    graphData: [],

    // Analysis detail drawer (on count click)
    graphDetailVisible: false,
    graphDetailLoading: false,
    graphDetailLabel: null,
    graphDetailData: [],
    graphDetailAccusedInfo: null,
    graphDetailPagination: {
      page: 1,
      limit: 10,
      total: 0,
    },
    graphDetailType: null,
    graphDetailParent: null,
    graphDetailFetchId: 0,

    // Static CCTV pattern overview (from Details — Master ID)
    patternOverviewVisible: false,
  };

  onStartDateChange = (date) => {
    if (date) {
      const startDate = date.toISOString();

      this.setState({
        startDate: startDate,
        // endDate: null,
      });
    }
  };
  onEndDateChange = (date) => {
    if (date) {
      const endDate = date.toISOString();

      this.setState({
        endDate: endDate,
      });
    }
  };
  setQuickRange = (type) => {
    let startDate = null;
    let endDate = moment();

    switch (type) {
      case "daily":
        startDate = moment();
        break;
      case "month":
        startDate = moment().startOf("month");
        break;
      case "6month":
        startDate = moment().subtract(6, "months");
        break;
      case "year":
        startDate = moment().subtract(1, "year");
        break;
      default:
        return;
    }

    this.setState({
      startDate: startDate.format("YYYY-MM-DD"),
      endDate: endDate.format("YYYY-MM-DD"),
      activeRange: type,
    });
  };
  // MAIN API LIST
  ApiLogs = () => {
    const { startDate, endDate } = this.state;
    this.setState({ loading: true });
    let obj = {
      startDate: startDate,
      endDate: endDate,
    };

    adminService.ApiLogs(obj).then((res) => {
      const data = res || [];
      let columns = [];

      // Sr No Column
      columns.push({
        title: "Sr. No",
        key: "srno",
        render: (text, record, index) => index + 1,
      });

      // Generate Dynamic Columns
      if (data.length > 0) {
        Object.keys(data[0]).forEach((key) => {
          // Static IP Column (Text Only)
          if (key === "static_ip") {
            columns.push({
              title: "STATIC IP",
              dataIndex: key,
              key,
            });
          }

          // API Columns → Clickable Buttons
          else {
            columns.push({
              title: key.toUpperCase(),
              key,
              render: (_, record) => (
                <Button
                  type="primary"
                  //   size="small"
                  //   shape="circle"
                  disabled={!record[key]} // disable if zero/null
                  onClick={() => {
                    this.openDrawer(key, record.static_ip);
                  }}
                >
                  {record[key] || 0}
                </Button>
              ),
            });
          }
        });
      }

      this.setState({ data, columns, loading: false });
    });
  };

  // OPEN DRAWER + LOAD DETAILS
  openDrawer = (apiType, selectedIP) => {
    const showExtraColumns =
      apiType === "/GET_BASICINFO_PDF" || apiType === "/GET_BASICINFO_JSON";

    this.setState(
      {
        is_show: showExtraColumns, // ✅ set true/false correctly
        drawerVisible: true,
        selectedApi: apiType,
        selectedIP: selectedIP,
        detailPagination: { page: 1, limit: 10, total: 0 },
      },
      () => this.ApiLogsDetails(),
    );
  };

  // LOAD DETAILS WITH PAGINATION
  ApiLogsDetails = () => {
    const { selectedApi, detailPagination, selectedIP, startDate, endDate } =
      this.state;

    this.setState({ detailLoading: true });

    adminService
      .ApiLogsDetails({
        callerIp: selectedIP,
        apiType: selectedApi,
        page: detailPagination.page,
        limit: detailPagination.limit,
        startDate: startDate,
        endDate: endDate,
      })
      .then((res) => {
        const page = detailPagination.page;
        const limit = detailPagination.limit;

        // Add Serial Number to Each Row
        const dataWithSrNo = (res.data || []).map((item, index) => ({
          srno: (page - 1) * limit + index + 1,
          ...item,
        }));

        this.setState({
          detailData: dataWithSrNo,
          detailPagination: {
            ...detailPagination,
            total: res.pagination?.total || 0,
          },
          detailLoading: false,
        });
      })
      .catch(() => {
        this.setState({ detailLoading: false });
      });
  };

  // PAGINATION CHANGE
  handleDetailPageChange = (page, limit) => {
    this.setState(
      {
        detailPagination: { ...this.state.detailPagination, page, limit },
      },
      () => this.ApiLogsDetails(),
    );
  };

  componentDidMount() {
    this.ApiLogs();
    this.props.dispatch(professionalAction.getAllMaster());
    this.props.dispatch(professionalAction.getCity());
    this.props.dispatch(professionalAction.getDharm());
    this.props.dispatch(professionalAction.getKalam());
    this.props.dispatch(professionalAction.getKayda());
    this.props.dispatch(professionalAction.getCrimeType());
    this.props.dispatch(professionalAction.getCrimeTitle());
    this.props.dispatch(professionalAction.getStatus());
  }

  openImageModal = (img, id) => {
    this.setState({
      imageOpen: true,
      selectedImage: img,
      crime_id: id,
    });
  };

  closeImageModal = () => {
    this.setState({ imageOpen: false, selectedImage: null, name: null });
  };
  showCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: true,
    });
  };
  onViewAccusedForm = (data) => {
    if (data) {
      this.showCriminalViewModel();
      this.props.dispatch(professionalAction.getCriminalsViewsById(data));
    }
  };

  closeCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: false,
    });
  };
  handleTableChange = (pagination, filters, sorter) => {
    this.setState({
      pagination: {
        ...this.state.pagination,
        ...pagination, // updates current and pageSize from AntD
      },
    });
  };

  openGraphModal = () => {
    this.setState(
      {
        graphDrawerVisible: true,
        graphType: "master_id",
      },
      () => this.fetchCctvLogAnalysis(),
    );
  };

  closeGraphModal = () => {
    this.setState({
      graphDrawerVisible: false,
      graphData: [],
      graphSummary: { distinctCount: 0, totalCount: 0 },
      graphDetailVisible: false,
      graphDetailData: [],
      graphDetailLabel: null,
      graphDetailAccusedInfo: null,
      graphDetailType: null,
      graphDetailParent: null,
    });
  };

  onGraphTypeChange = (e) => {
    const value = e?.target?.value ?? e;
    this.setState({ graphType: value }, () => this.fetchCctvLogAnalysis());
  };

  openGraphDetail = (label, type) => {
    if (!label) return;
    const detailType = type || this.state.graphType;
    const isDrillDown =
      this.state.graphDetailVisible &&
      type === "master_id" &&
      (this.state.graphDetailType || this.state.graphType) !== "master_id";

    const parentSnapshot = isDrillDown
      ? {
          label: this.state.graphDetailLabel,
          type: this.state.graphDetailType || this.state.graphType,
          data: (this.state.graphDetailData || []).map((row) => ({ ...row })),
          pagination: { ...this.state.graphDetailPagination },
          accusedInfo: this.state.graphDetailAccusedInfo
            ? { ...this.state.graphDetailAccusedInfo }
            : null,
        }
      : null;

    this.setState(
      {
        graphDetailVisible: true,
        graphDetailLabel: label,
        graphDetailType: detailType,
        graphDetailAccusedInfo: null,
        graphDetailData: [],
        graphDetailPagination: { page: 1, limit: 10, total: 0 },
        graphDetailParent: parentSnapshot,
        graphDetailFetchId: (this.state.graphDetailFetchId || 0) + 1,
      },
      () => this.fetchCctvLogAnalysisDetails(),
    );
  };

  closeGraphDetail = () => {
    const { graphDetailParent } = this.state;
    this.ignoreGraphDetailPageChange = true;
    if (graphDetailParent) {
      this.setState(
        {
          graphDetailLabel: graphDetailParent.label,
          graphDetailType: graphDetailParent.type,
          graphDetailData: (graphDetailParent.data || []).map((row) => ({
            ...row,
          })),
          graphDetailPagination: { ...graphDetailParent.pagination },
          graphDetailAccusedInfo: graphDetailParent.accusedInfo,
          graphDetailParent: null,
          graphDetailLoading: false,
          graphDetailFetchId: (this.state.graphDetailFetchId || 0) + 1,
          patternOverviewVisible: false,
        },
        () => {
          this.ignoreGraphDetailPageChange = false;
        },
      );
      return;
    }
    this.setState(
      {
        graphDetailVisible: false,
        graphDetailData: [],
        graphDetailLabel: null,
        graphDetailAccusedInfo: null,
        graphDetailType: null,
        graphDetailParent: null,
        graphDetailLoading: false,
        graphDetailFetchId: (this.state.graphDetailFetchId || 0) + 1,
        patternOverviewVisible: false,
      },
      () => {
        this.ignoreGraphDetailPageChange = false;
      },
    );
  };

  openPatternOverview = () => {
    this.setState({ patternOverviewVisible: true });
  };

  closePatternOverview = () => {
    this.setState({ patternOverviewVisible: false });
  };

  fetchCctvLogAnalysisDetails = () => {
    const {
      startDate,
      endDate,
      graphType,
      graphDetailLabel,
      graphDetailPagination,
      graphDetailFetchId,
    } = this.state;
    const detailType = this.state.graphDetailType || graphType;
    const fetchId = graphDetailFetchId;

    this.setState({ graphDetailLoading: true });

    adminService
      .CctvLogAnalysisDetails({
        startDate,
        endDate,
        type: detailType,
        label: String(graphDetailLabel),
        page: graphDetailPagination.page,
        limit: graphDetailPagination.limit,
      })
      .then((res) => {
        if (fetchId !== this.state.graphDetailFetchId) {
          return;
        }
        const page = graphDetailPagination.page;
        const limit = graphDetailPagination.limit;
        const dataWithSrNo = (res?.data || []).map((item, index) => ({
          srno: (page - 1) * limit + index + 1,
          ...item,
        }));

        this.setState({
          graphDetailData: dataWithSrNo,
          graphDetailAccusedInfo: res?.accusedInfo || null,
          graphDetailPagination: {
            ...this.state.graphDetailPagination,
            total: res?.pagination?.total || 0,
          },
          graphDetailLoading: false,
        });
      })
      .catch(() => {
        if (fetchId !== this.state.graphDetailFetchId) {
          return;
        }
        this.setState({
          graphDetailData: [],
          graphDetailAccusedInfo: null,
          graphDetailLoading: false,
        });
      });
  };

  handleGraphDetailPageChange = (page, limit) => {
    if (this.ignoreGraphDetailPageChange) {
      return;
    }
    if (
      this.state.graphDetailPagination.page === page &&
      this.state.graphDetailPagination.limit === limit
    ) {
      return;
    }
    this.setState(
      {
        graphDetailPagination: {
          ...this.state.graphDetailPagination,
          page,
          limit,
        },
        graphDetailFetchId: (this.state.graphDetailFetchId || 0) + 1,
      },
      () => this.fetchCctvLogAnalysisDetails(),
    );
  };

  fetchCctvLogAnalysis = () => {
    const { startDate, endDate, graphType } = this.state;
    this.setState({ graphLoading: true });

    adminService
      .CctvLogAnalysis({
        startDate,
        endDate,
        type: graphType,
      })
      .then((res) => {
        this.setState({
          graphData: res?.data || [],
          graphSummary: {
            distinctCount: res?.distinctCount || 0,
            totalCount: res?.totalCount || 0,
          },
          graphLoading: false,
        });
      })
      .catch(() => {
        this.setState({
          graphData: [],
          graphSummary: { distinctCount: 0, totalCount: 0 },
          graphLoading: false,
        });
      });
  };

  getGraphColumns = () => {
    const { graphType } = this.state;
    const labelTitle =
      graphType === "district"
        ? "District Name"
        : graphType === "city"
          ? "City Name"
          : "CMIS ID";

    const columns = [
      {
        title: "Sr. No",
        key: "srno",
        width: 80,
        align: "center",
        render: (_, __, index) => <span>{index + 1}</span>,
      },
      {
        title: labelTitle,
        dataIndex: "label",
        key: "label",
        render: (text) => (
          <span style={{ fontWeight: 600, color: "#1a1a2e" }}>
            {text || "-"}
          </span>
        ),
      },
    ];

    // Name of Accused + Police Station + Ongoing Preventive Action only for Master ID view
    if (graphType === "master_id") {
      columns.push({
        title: "Name of Accused",
        dataIndex: "accusedName",
        key: "accusedName",
        render: (text) => text || "-",
      });
      columns.push({
        title: "Police Station",
        dataIndex: "districtName",
        key: "districtName",
        render: (text) => text || "-",
      });
      columns.push({
        title: "Ongoing Preventive Action",
        dataIndex: "preventiveActionName",
        key: "preventiveActionName",
        render: (text) => text || "-",
      });
    }

    columns.push({
      title: "Found In CCTV",
      dataIndex: "count",
      key: "count",
      align: "center",
      width: 120,
      render: (text, record) => (
        <Button
          type="primary"
          size="middle"
          shape="circle"
          disabled={!text}
          onClick={() => this.openGraphDetail(record.label)}
        >
          {text || 0}
        </Button>
      ),
    });

    return columns;
  };

  getGraphTypeReportName = () => {
    const { graphType } = this.state;
    if (graphType === "district") return "पो. स्टे निहाय";
    if (graphType === "city") return "घटक निहाय";
    return "आरोपी निहाय";
  };

  downloadGraphExcel = () => {
    const { graphData, graphType, startDate, endDate } = this.state;
    const { t } = this.context;

    if (!graphData || graphData.length === 0) {
      message.warning("No data available to download");
      return;
    }

    const ReportTitle = this.getGraphTypeReportName();
    const file_name = `${ReportTitle}_${moment().format("DDMMMYYYY")}`;

    let arrData = [];

    if (graphType === "master_id") {
      arrData = graphData.map((data, index) => ({
        [t("sr.no") || "Sr. No"]: index + 1,
        "CMIS ID": data.label || "-",
        "Name of Accused": data.accusedName || "-",
        "Police Station": data.districtName || "-",
        "Ongoing Preventive Action": data.preventiveActionName || "-",
        "Found In CCTV": data.count || 0,
      }));
    } else if (graphType === "district") {
      arrData = graphData.map((data, index) => ({
        [t("sr.no") || "Sr. No"]: index + 1,
        "District Name": data.label || "-",
        "Found In CCTV": data.count || 0,
      }));
    } else {
      arrData = graphData.map((data, index) => ({
        [t("sr.no") || "Sr. No"]: index + 1,
        "City Name": data.label || "-",
        "Found In CCTV": data.count || 0,
      }));
    }

    const ws = XLSX.utils.json_to_sheet(arrData, { origin: "A3" });

    const columnWidths = Object.keys(arrData[0]).map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length),
        ) + 6,
    }));

    ws["!cols"] = columnWidths;

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    Object.keys(arrData[0]).forEach((_, colIndex) => {
      const cellRef = XLSX.utils.encode_cell({ r: 2, c: colIndex });
      if (ws[cellRef]) {
        ws[cellRef].s = headerStyle;
      }
    });

    arrData.forEach((row, rowIndex) => {
      Object.values(row).forEach((_, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({
          r: rowIndex + 3,
          c: colIndex,
        });
        if (ws[cellRef]) {
          ws[cellRef].s = cellStyle;
        }
      });
    });

    // Report name = graph type (no city name header)
    ws["A1"] = { v: ReportTitle, t: "s" };
    ws["A1"].s = titleStyle;

    ws["A2"] = {
      v: `From: ${
        startDate ? moment(startDate).format("DD-MM-YYYY") : "-"
      } To ${endDate ? moment(endDate).format("DD-MM-YYYY") : "-"}`,
      t: "s",
    };
    ws["A2"].s = subTitleStyle;

    const footerContent = `Generated At ${moment(new Date()).format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;

    const footerRowIndex = arrData.length + 5;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const mergeRanges = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnWidths.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: columnWidths.length - 1 } },
      {
        s: { r: footerRowIndex - 1, c: 0 },
        e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
      },
    ];

    ws["!merges"] = mergeRanges;
    ws["!rows"] = Array(footerRowIndex).fill({ hpt: 25 });
    ws["!rows"][footerRowIndex - 1] = { hpt: 40 };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");
    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  render() {
    const {
      data,
      columns,
      loading,
      drawerVisible,
      detailData,
      detailLoading,
      detailPagination,
      selectedApi,
      is_show,
      pagination,
      graphDrawerVisible,
      graphLoading,
      graphType,
      graphSummary,
      graphData,
      graphDetailVisible,
      graphDetailLoading,
      graphDetailLabel,
      graphDetailData,
      graphDetailAccusedInfo,
      graphDetailPagination,
      graphDetailType,
      patternOverviewVisible,
    } = this.state;
    const { t } = this.context;
    const detailType = graphDetailType || graphType;
    const hiddenKeys = [
      "body",
      "apiKey",
      "apiKeyId",
      "queryParams",
      "pathParams",
      "headers",
      "stage",
      "masterId",
      "photo",
    ]; // keys to hide

    const hiddenBasicKeys = [
      "body",
      "apiKey",
      "apiKeyId",
      "queryParams",
      "pathParams",
      "headers",
      "stage",
    ];

    console.log("detailData", detailData);
    const detailColumns =
      selectedApi === "/get_basicinfo_json" ||
      selectedApi === "/get_basicinfo_pdf"
        ? detailData.length > 0
          ? (() => {
              let columns = Object.keys(detailData[0])
                .filter(
                  (key) =>
                    !hiddenBasicKeys.includes(key) &&
                    key !== "masterId" &&
                    key !== "photo",
                )
                .map((key) => {
                  // FORMAT TIME COLUMN
                  if (key === "time") {
                    return {
                      title: key.replace(/_/g, " ").toUpperCase(),
                      dataIndex: key,
                      key,
                      render: (text) =>
                        text
                          ? new Date(text.replace(" ", "T")).toLocaleString(
                              "en-IN",
                              {
                                timeZone: "Asia/Kolkata",
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              },
                            )
                          : "-",
                    };
                  }

                  return {
                    title: key.replace(/_/g, " ").toUpperCase(),
                    dataIndex: key,
                    key,
                  };
                });

              columns.push({
                title: "MASTER ID",
                dataIndex: "masterId",
                key: "masterId",
                render: (text) => (text ? text : "-"),
              });

              columns.push({
                ...{
                  title: t("photo"),
                  key: "photo",
                  render: (text, record) => (
                    <Space size="middle">
                      {record.photo &&
                      record.photo.length > 0 &&
                      record.photo[0].trim() !== "" ? (
                        <img
                          style={{ width: 50, height: 50 }}
                          src={
                            "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
                            record.photo
                          }
                          onClick={() =>
                            this.openImageModal(record.photo, record.masterId)
                          }
                        ></img>
                      ) : (
                        t("no")
                      )}
                    </Space>
                  ),
                },
              });

              columns.push({
                title: t("action"),
                key: "action",
                render: (_, record) => (
                  <div
                    className="action-links-responsive"
                    style={{ justifyContent: "center" }}
                  >
                    <Button
                      type="primary"
                      onClick={() => {
                        this.onViewAccusedForm(record.masterId);
                      }}
                      className="action-link update-link"
                    >
                      {t("view1")}
                    </Button>
                  </div>
                ),
              });

              return columns;
            })()
          : []
        : detailData.length > 0
          ? (() => {
              let columns = Object.keys(detailData[0])
                .filter((key) => !hiddenKeys.includes(key))
                .map((key) => {
                  // FORMAT TIME COLUMN
                  if (key === "time") {
                    return {
                      title: key.replace(/_/g, " ").toUpperCase(),
                      dataIndex: key,
                      key,
                      render: (text) =>
                        text
                          ? new Date(text.replace(" ", "T")).toLocaleString(
                              "en-IN",
                              {
                                timeZone: "Asia/Kolkata",
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              },
                            )
                          : "-",
                    };
                  }

                  return {
                    title: key.replace(/_/g, " ").toUpperCase(),
                    dataIndex: key,
                    key,
                  };
                });

              return columns;
            })()
          : [];

    return (
      <>
        {/* MAIN TABLE */}
        <div className="site-page-header-ghost-wrapper">
          <PageHeader
            title="Cctv log"
            extra={[
              <Button
                key="graph"
                type="primary"
                icon={<BarChartOutlined />}
                onClick={this.openGraphModal}
              >
                Graph Analysis
              </Button>,
            ]}
          />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              flexWrap: "wrap",
              padding: "12px",
              background: "#fff",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              marginBottom: "12px",
            }}
          >
            <span style={{ fontSize: "14px", fontWeight: 500 }}>
              {t("select_date")}:
            </span>
            {/* Quick Buttons */}
            <Space>
              <Button
                size="small"
                type={
                  this.state.activeRange === "daily" ? "primary" : "default"
                }
                onClick={() => this.setQuickRange("daily")}
              >
                Daily
              </Button>

              <Button
                size="small"
                type={
                  this.state.activeRange === "month" ? "primary" : "default"
                }
                onClick={() => this.setQuickRange("month")}
              >
                Month
              </Button>

              <Button
                size="small"
                type={
                  this.state.activeRange === "6month" ? "primary" : "default"
                }
                onClick={() => this.setQuickRange("6month")}
              >
                6 Month
              </Button>

              <Button
                size="small"
                type={this.state.activeRange === "year" ? "primary" : "default"}
                onClick={() => this.setQuickRange("year")}
              >
                1 Year
              </Button>
            </Space>
            {/* Range Picker */}
            <DatePicker
              value={
                this.state.startDate ? moment(this.state.startDate) : moment()
              }
              onChange={this.onStartDateChange}
              placeholder="DD/MM/YYYY"
              inputReadOnly
              format="DD/MM/YYYY"
              style={{ minWidth: "150px" }}
            />{" "}
            <DatePicker
              value={this.state.endDate ? moment(this.state.endDate) : moment()}
              onChange={this.onEndDateChange}
              placeholder="DD/MM/YYYY"
              inputReadOnly
              format="DD/MM/YYYY"
              style={{ minWidth: "150px" }}
            />
            <Button
              type="primary"
              disabled={!this.state.startDate}
              loading={this.state.loader}
              onClick={this.ApiLogs}
            >
              {t("find")}
            </Button>
          </div>
        </div>
        <Table
          bordered
          loading={loading}
          columns={columns}
          dataSource={data}
          rowKey={(record, index) => index}
          rowClassName={() => "govt-table-row"}
          scroll={{ x: "100%" }}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            showSizeChanger: true,
          }}
          onChange={this.handleTableChange}
        />

        {/* DRAWER */}
        <Drawer
          title={`API Logs — ${selectedApi}`}
          placement="right"
          width={900}
          onClose={() =>
            this.setState({ drawerVisible: false, is_show: false })
          }
          open={drawerVisible}
          closable={false}
          footer={
            <div style={{ textAlign: "right" }}>
              <Button
                danger
                onClick={() =>
                  this.setState({ drawerVisible: false, is_show: false })
                }
              >
                Close
              </Button>
            </div>
          }
        >
          <Table
            bordered
            loading={detailLoading}
            columns={detailColumns}
            dataSource={detailData}
            rowKey={(record, index) => index}
            pagination={{
              current: detailPagination.page,
              pageSize: detailPagination.limit,
              total: detailPagination.total,
              showSizeChanger: true,
              onChange: this.handleDetailPageChange,
            }}
            scroll={{ x: "100%" }}
          />
        </Drawer>
        <Drawer
          title={
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <BarChartOutlined style={{ fontSize: 18, color: "#1890ff" }} />
              <span>CCTV Log Analysis</span>
            </div>
          }
          placement="right"
          width={820}
          onClose={this.closeGraphModal}
          open={graphDrawerVisible}
          destroyOnClose
          closable={false}
          footer={
            <div style={{ textAlign: "right" }}>
              <Button onClick={this.closeGraphModal}>Close</Button>
            </div>
          }
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 12,
              marginBottom: 16,
              padding: "12px 14px",
              background: "#fafafa",
              borderRadius: 8,
              border: "1px solid #f0f0f0",
            }}
          >
            <div
              style={{
                padding: "8px 14px",
                background: "#fff",
                borderRadius: 6,
                border: "1px solid #e8e8e8",
                fontWeight: 600,
                fontSize: 14,
              }}
            >
              एकूण:{" "}
              <strong style={{ color: "#1890ff" }}>{graphData.length}</strong>
            </div>
            <Radio.Group
              value={graphType}
              onChange={this.onGraphTypeChange}
              buttonStyle="solid"
              size="middle"
            >
              <Radio.Button value="master_id">
                <TeamOutlined /> आरोपी निहाय
              </Radio.Button>
              <Radio.Button value="district">
                <BankOutlined /> पो. स्टे निहाय
              </Radio.Button>
              <Radio.Button value="city">
                <EnvironmentOutlined /> घटक निहाय
              </Radio.Button>
            </Radio.Group>
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              onClick={this.downloadGraphExcel}
              disabled={!graphData || graphData.length === 0}
            >
              Download Excel
            </Button>
          </div>

          <Table
            bordered
            size="middle"
            loading={graphLoading}
            columns={this.getGraphColumns()}
            dataSource={graphData}
            rowKey={(record, index) => `${record.label}-${index}`}
            pagination={{
              pageSize: 10,
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} records`,
            }}
            scroll={{ x: "100%", y: "calc(100vh - 280px)" }}
            locale={{
              emptyText: graphLoading
                ? "Loading..."
                : "No GET_BASICINFO_PDF data for selected date range",
            }}
          />
        </Drawer>

        {/* Analysis detail drawer — clicked count */}
        <Drawer
          title={
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <TeamOutlined style={{ fontSize: 18, color: "#722ed1" }} />
              <span>
                Details —{" "}
                {detailType === "district"
                  ? "District"
                  : detailType === "city"
                    ? "City"
                    : "Master ID"}
                : {graphDetailLabel || "-"}
              </span>
            </div>
          }
          placement="right"
          width={980}
          onClose={this.closeGraphDetail}
          open={graphDetailVisible}
          destroyOnClose
          closable={false}
          zIndex={1100}
          footer={
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {detailType === "master_id" ? (
                <Button
                  type="primary"
                  icon={<BarChartOutlined />}
                  onClick={this.openPatternOverview}
                >
                  Graph
                </Button>
              ) : (
                <span />
              )}
              <Button onClick={this.closeGraphDetail}>Back</Button>
            </div>
          }
        >
          {detailType === "master_id" ? (
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: 12,
                marginBottom: 16,
                padding: "12px 14px",
                background: "#fafafa",
                borderRadius: 8,
                border: "1px solid #f0f0f0",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  padding: "8px 14px",
                  background: "#fff",
                  borderRadius: 6,
                  border: "1px solid #e8e8e8",
                  fontSize: 13,
                  fontWeight: 600,
                }}
              >
                एकूण:{" "}
                <strong style={{ color: "#1890ff" }}>
                  {graphDetailPagination.total ?? 0}
                </strong>
              </div>
              <div
                style={{
                  padding: "8px 14px",
                  background: "#fff",
                  borderRadius: 6,
                  border: "1px solid #e8e8e8",
                  fontSize: 13,
                  fontWeight: 600,
                }}
              >
                पो. स्टे.:{" "}
                <strong style={{ color: "#1890ff" }}>
                  {graphDetailAccusedInfo?.policeStation || "-"}
                </strong>
              </div>
              <div
                style={{
                  padding: "8px 14px",
                  background: "#fff",
                  borderRadius: 6,
                  border: "1px solid #e8e8e8",
                  fontSize: 13,
                  fontWeight: 600,
                }}
              >
                Ongoing Preventive Action:{" "}
                <strong style={{ color: "#722ed1" }}>
                  {graphDetailAccusedInfo?.preventiveActionName || "-"}
                </strong>
              </div>
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                onClick={this.openPatternOverview}
                style={{ marginLeft: "auto" }}
              >
                Graph
              </Button>
            </div>
          ) : (
            <div
              style={{
                marginBottom: 16,
                padding: "8px 14px",
                background: "#fff",
                borderRadius: 6,
                border: "1px solid #e8e8e8",
                fontSize: 13,
                fontWeight: 600,
                display: "inline-block",
              }}
            >
              एकूण:{" "}
              <strong style={{ color: "#1890ff" }}>
                {graphDetailPagination.total ?? 0}
              </strong>
            </div>
          )}
          <Table
            bordered
            size="middle"
            loading={graphDetailLoading}
            dataSource={graphDetailData}
            rowKey={(record, index) =>
              `${detailType}-${record.masterId || ""}-${record.id || ""}-${
                record.time || ""
              }-${index}`
            }
            scroll={{ x: "100%" }}
            pagination={{
              current: graphDetailPagination.page,
              pageSize: graphDetailPagination.limit,
              total: graphDetailPagination.total,
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} records`,
              onChange: this.handleGraphDetailPageChange,
            }}
            columns={
              detailType === "district" || detailType === "city"
                ? [
                    {
                      title: "Sr. No",
                      dataIndex: "srno",
                      key: "srno",
                      width: 70,
                      align: "center",
                    },
                    {
                      title: "CMIS ID",
                      dataIndex: "masterId",
                      key: "masterId",
                      width: 110,
                      render: (text) => text || "-",
                    },
                    {
                      title: "Name of Accused",
                      dataIndex: "accusedName",
                      key: "accusedName",
                      render: (text) => text || "-",
                    },
                    {
                      title: "Police Station",
                      dataIndex: "districtName",
                      key: "districtName",
                      render: (text) => text || "-",
                    },
                    {
                      title: "Ongoing Preventive Action",
                      dataIndex: "preventiveActionName",
                      key: "preventiveActionName",
                      render: (text) => text || "-",
                    },
                    {
                      title: "Found In CCTV",
                      dataIndex: "count",
                      key: "count",
                      align: "center",
                      width: 120,
                      render: (text, record) => (
                        <Button
                          type="primary"
                          size="middle"
                          shape="circle"
                          disabled={!text}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.openGraphDetail(record.masterId, "master_id");
                          }}
                        >
                          {text || 0}
                        </Button>
                      ),
                    },
                    {
                      title: t("action"),
                      key: "action",
                      width: 100,
                      align: "center",
                      render: (_, record) => (
                        <Button
                          type="primary"
                          size="small"
                          disabled={!record.masterId}
                          onClick={() =>
                            this.onViewAccusedForm(record.masterId)
                          }
                        >
                          {t("view1")}
                        </Button>
                      ),
                    },
                  ]
                : [
                    {
                      title: "Sr. No",
                      dataIndex: "srno",
                      key: "srno",
                      width: 70,
                      align: "center",
                    },
                    {
                      title: "Time",
                      dataIndex: "time",
                      key: "time",
                      width: 180,
                      render: (text) =>
                        text
                          ? new Date(
                              String(text).replace(" ", "T"),
                            ).toLocaleString("en-IN", {
                              timeZone: "Asia/Kolkata",
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })
                          : "-",
                    },
                    {
                      title: "Caller IP",
                      dataIndex: "callerIp",
                      key: "callerIp",
                      width: 140,
                      render: (text) => text || "-",
                    },
                    {
                      title: "Resource Path",
                      dataIndex: "resourcePath",
                      key: "resourcePath",
                      width: 180,
                      render: (text) => text || "-",
                    },
                    {
                      title: "Master ID",
                      dataIndex: "masterId",
                      key: "masterId",
                      width: 110,
                      render: (text) => text || "-",
                    },
                    {
                      title: t("action"),
                      key: "action",
                      width: 100,
                      align: "center",
                      render: (_, record) => (
                        <Button
                          type="primary"
                          size="small"
                          disabled={!record.masterId}
                          onClick={() =>
                            this.onViewAccusedForm(record.masterId)
                          }
                        >
                          {t("view1")}
                        </Button>
                      ),
                    },
                  ]
            }
          />
        </Drawer>

        <CctvPatternOverviewStatic
          open={patternOverviewVisible}
          onClose={this.closePatternOverview}
          masterId={graphDetailLabel}
          accusedName={graphDetailAccusedInfo?.accusedName}
          policeStation={graphDetailAccusedInfo?.policeStation}
          startDate={this.state.startDate}
          endDate={this.state.endDate}
        />

        <ImageView
          imageOpen={this.state.imageOpen}
          imageUrl={
            "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
            this.state.selectedImage
          }
          name={this.state.name}
          onClose={this.closeImageModal}
          id={this.state.crime_id}
        />
        <Modal
          title="आरोपी प्रोफाइल"
          top
          visible={this.state.setCriminalViewModel}
          onOk={this.closeCriminalViewModel}
          onCancel={this.closeCriminalViewModel}
          width={95 + "%"}
        >
          <ViewFormModel
            key={this.props && this.props.user.id}
            dataStates={this.props.professionals}
            preventiveAction={this.state.preventiveAction}
          ></ViewFormModel>
        </Modal>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}

export default connect(mapStateToProps)(ApiLog);
